import { ModalManager } from "./components/ModalManager.js";

ModalManager.use();
